import { createRoutine } from 'redux-saga-routines'
import { IPracticeState } from './index.interface'

const initialPracticeState: IPracticeState = {
  practices: [],
  selectedPractice: null,
  loading: false,
  submitting: false,
  invitationSuccess: false,
  error: false,
  success: false,
  message: '',
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0
  },
}

export const getPractices = createRoutine('GET_ORGANIZATIONS')
export const showPractice = createRoutine('SHOW_ORGANIZATION')
export const createPractice = createRoutine('SIGNUP_ORGANIZATION')
export const editPractice = createRoutine('EDIT_ORGANIZATION')
export const clearInvitationStatus = createRoutine('CLEAR_INVITATION_STATUS')


export default (state = initialPracticeState, action: any) => {
  switch (action.type) {
    // get Practice
    case getPractices.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: '',
        practices: []
      }
    case getPractices.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        practices: action.payload.organizations,
        meta: action.payload.meta
      }
    case getPractices.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: action.payload,
        practices: []
      }
    // show Practice
    case showPractice.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: '',
        selectedPractice: initialPracticeState.selectedPractice
      }
    case showPractice.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        selectedPractice: action.payload
      }
    case showPractice.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: action.payload,
        selectedPractice: initialPracticeState.selectedPractice

      }

    // Signup Practice
    case createPractice.TRIGGER:
      return {
        ...state,
        error: false,
        submitting: true,
        success: false,
        invitationSuccess: false,
        message: ''
      }
    case createPractice.SUCCESS:
      return {
        ...state,
        error: false,
        submitting: false,
        invitationSuccess: true,
        success: true,
        message: ''
      }
    case createPractice.FAILURE:
      return {
        ...state,
        error: true,
        submitting: false,
        success: false,
        invitationSuccess: false,
        message: action.payload
      }

    // Edit Practice
    case editPractice.TRIGGER:
      return {
        ...state,
        error: false,
        submitting: true,
        success: false,
        message: ''
      }
    case editPractice.SUCCESS:
      return {
        ...state,
        error: false,
        submitting: false,
        success: true,
        selectedPractice: action.payload
      }
    case editPractice.FAILURE:
      return {
        ...state,
        error: true,
        submitting: false,
        success: false,
        message: action.payload
      }
    case clearInvitationStatus.TRIGGER:
      return {
        ...state,
        invitationSuccess: false,
      }
    default:
      return { ...state }
  }
}
